module.exports = __webpack_public_path__ + "static/media/insentBotIcon2x.57e92423.png";